import React, { useState } from "react";
import axios from 'axios';
import {
  ContactWrapper,
  FormWrapper,
  GradientBackground,
  FormContainer,
  Title,
  Description,
  Input,
  Textarea,
  Button,
  FormActions,
  SuccessModal,
  ModalContent,
  CloseButton
} from "./ContactElements";
import ScrollAnimation from "react-animate-on-scroll";

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null); // For handling error feedback

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Validate form fields
  const isFormValid = () => {
    return formData.name && formData.email && formData.subject && formData.message;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      setError("All fields are required.");
      return;
    }

    try {
      const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:5000/api'
    : 'https://dibyanjaya-portfolio-backend.onrender.com/api');

const response = await axios.post(`${API_BASE_URL}/contact`, formData);

      console.log(response.data);
      setSuccess(true);
      setError(null); // Clear error on success
      setFormData({ name: '', email: '', subject: '', message: '' }); // Reset form
      setTimeout(() => setSuccess(false), 2000);
    } catch (error) {
      console.error('Error sending message:', error.response ? error.response.data : error.message);
      setError(`Failed to send message: ${error.response ? error.response.data : error.message}`);
    }
  };

  return (
    <ContactWrapper id="contact">
      <div className="Container">
        <div className="SectionTitle">Get In Touch</div>
        <ScrollAnimation animateIn="fadeIn">
          <FormWrapper>
            <GradientBackground />
            <FormContainer>
              <Title>Contact Us!</Title>
              <Description>Fill up the form below to send us a message.</Description>
              {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>} {/* Display errors */}
              <form onSubmit={handleSubmit}>
                <Input
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <Input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <Input
                  type="text"
                  placeholder="Subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
                <Textarea
                  placeholder="Type your message here..."
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
                <FormActions>
                  <Button type="submit">Send ➤</Button>
                  <Button
                    type="reset"
                    onClick={() => setFormData({ name: '', email: '', subject: '', message: '' })}
                  >
                    Reset
                  </Button>
                </FormActions>
              </form>
            </FormContainer>
          </FormWrapper>
        </ScrollAnimation>
      </div>
      {success && (
        <SuccessModal>
          <ModalContent>
            <CloseButton onClick={() => setSuccess(false)}>×</CloseButton>
            <p>Thank you for contacting us! We got your message.</p>
          </ModalContent>
        </SuccessModal>
      )}
    </ContactWrapper>
  );
}

export default Contact;
